import { render, staticRenderFns } from "./WechatPayAlert.vue?vue&type=template&id=1abf4142&"
import script from "./WechatPayAlert.vue?vue&type=script&lang=js&"
export * from "./WechatPayAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports